<template>
  <div style="background-color: #f6f6f6; padding-bottom: 50px">
    <Search></Search>
    <HomeNav></HomeNav>
    <!-- 商品显示区域 -->
    <div class="content">
      <!-- 秒杀 -->
      <div class="seckill">
        <!-- 头部 -->
        <div class="seckill-head">
          <div class="seckill-icon">
            <img src="static/img/index/clock.png" />
          </div>
          <div class="seckill-text">
            <span class="seckill-title">限时秒杀</span>
            <span class="seckill-remarks">总有你想不到的低价</span>
          </div>
          <div class="count-down">
            <span class="count-down-text">当前场次</span>
            <span class="count-down-num count-down-hour">{{
              seckillsHours
            }}</span>
            <span class="count-down-point">:</span>
            <span class="count-down-num count-down-minute">{{
              seckillsMinutes
            }}</span>
            <span class="count-down-point">:</span>
            <span class="count-down-num count-down-seconds">{{
              seckillsSeconds
            }}</span>
            <span class="count-down-text">后结束抢购</span>
          </div>
        </div>
        <!-- 内容 -->
        <div class="seckill-content">
          <div
            class="seckill-item"
            v-for="(item, index) in seckills.goodsList"
            :key="index"
          >
            <div class="seckill-item-img">
              <router-link
                :to="{
                  path: '/goodsDetail',
                  query: {
                    cata: item.firCata,
                    secCata: item.cataid,
                    id: item.id,
                  },
                }"
                ><img :src="item.img"
              /></router-link>
            </div>
            <div class="seckill-item-info">
              <p style="height: 36px">{{ item.intro }}</p>
              <p>
                <span class="seckill-price text-danger"
                  ><Icon type="social-yen"></Icon>{{ item.price }}</span
                >
                <span class="seckill-old-price"
                  ><s>¥{{ item.realPrice }}</s></span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 百货专场 -->
      <div class="item-class">
        <div class="item-class-head">
          <!-- <div class="item-class-title">{{ eat.title }}</div> -->
          <img src="../../static/img/index/title-bh.png" width="100%" class="title-img" alt="title">
          <ul class="item-class-cata item-class-cata-baihuo" v-if="cata[0]">
            <li v-for="(item, index) in cata[0].secCata" :key="index">
              <router-link
                :to="{
                  path: '/goodsList',
                  query: { cata: eat.id, secCata: item.id },
                }"
                >{{ item.label }}</router-link
              >
            </li>
          </ul>
        </div>
        <div class="item-class-content_wrap content-baihuo">
          <div
            class="item-class-content"
            v-for="(item, index) in eat.detail"
            :key="index"
          >
            <div class="item-content-top">
              <div class="item-big-img">
                <!-- <router-link :to="{path: '/goodsList', query: {cata: eat.id, secCata: 'all'}}"> -->
                <img :src="item.bigImg" width="180" alt="" />
                <!-- </router-link> -->
              </div>
              <div class="item-four-img">
                <div
                  class="item-four-detail"
                  v-for="(subItem, index) in item.itemFour"
                  :key="index"
                >
                  <router-link
                    :to="{
                      path: '/goodsList',
                      query: { cata: eat.id, secCata: subItem.secCata },
                    }"
                  >
                    <div class="item-four-detail-text">
                      <p class="pt_bi_tit pt_bi_tit-eat">{{ subItem.title }}</p>
                      <p class="pt_bi_promo">{{ subItem.intro }}</p>
                    </div>
                    <div class="item-four-detail-img">
                      <img :src="subItem.img" alt="" />
                      <router-link
                        :to="{
                          path: '/goodsList',
                          query: { cata: eat.id, secCata: subItem.secCata },
                        }"
                      >
                      </router-link>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 办公用品专场 -->
      <div class="item-class">
        <div class="item-class-head">
          <!-- <div class="item-class-title">{{ office.title }}</div> -->
          <img src="../../static/img/index/title-yp.png" width="100%" class="title-img" alt="title">
          <ul class="item-class-cata item-class-cata-bangong" v-if="cata[2]">
            <li v-for="(item, index) in cata[2].secCata" :key="index">
              <router-link
                :to="{
                  path: '/goodsList',
                  query: { cata: office.id, secCata: item.id },
                }"
                >{{ item.label }}</router-link
              >
            </li>
          </ul>
        </div>
        <div class="item-class-content_wrap content-bangong">
          <div
            class="item-class-content"
            v-for="(item, index) in office.detail"
            :key="index"
          >
            <div class="item-content-top">
              <div class="item-big-img">
                <!-- <router-link :to="{path: '/goodsList', query: {cata: office.id, secCata: 'all'}}"> -->
                <img :src="item.bigImg" width="180" alt="" />
                <!-- </router-link> -->
              </div>
              <div class="item-four-img">
                <div
                  class="item-four-detail"
                  v-for="(subItem, index) in item.itemFour"
                  :key="index"
                >
                  <router-link
                    :to="{
                      path: '/goodsList',
                      query: { cata: office.id, secCata: subItem.secCata },
                    }"
                  >
                    <div class="item-four-detail-text">
                      <p class="pt_bi_tit pt_bi_tit-bangong">
                        {{ subItem.title }}
                      </p>
                      <p class="pt_bi_promo">{{ subItem.intro }}</p>
                    </div>
                    <div class="item-four-detail-img">
                      <img :src="subItem.img" alt="" />
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 电脑专场 -->
      <div class="item-class">
        <div class="item-class-head">
          <!-- <div class="item-class-title">{{ computer.title }}</div> -->
          <img src="../../static/img/index/title-sm.png" width="100%" class="title-img" alt="title">
          <ul class="item-class-cata item-class-cata-dianzi" v-if="cata[1]">
            <li v-for="(item, index) in cata[1].secCata" :key="index">
              <router-link
                :to="{
                  path: '/goodsList',
                  query: { cata: computer.id, secCata: item.id },
                }"
                >{{ item.label }}</router-link
              >
            </li>
          </ul>
        </div>
        <div class="item-class-content_wrap content-dinazi">
          <div
            class="item-class-content"
            v-for="(item, index) in computer.detail"
            :key="index"
          >
            <div class="item-content-top">
              <div class="item-big-img">
                <!-- <router-link :to="{path: '/goodsList', query: {cata: computer.id, secCata: 'all'}}"> -->
                <img :src="item.bigImg" alt="" />
                <!-- </router-link> -->
              </div>
              <div class="item-four-img">
                <div
                  class="item-four-detail"
                  v-for="(subItem, index) in item.itemFour"
                  :key="index"
                >
                  <router-link
                    :to="{
                      path: '/goodsList',
                      query: { cata: computer.id, secCata: subItem.secCata },
                    }"
                  >
                    <div class="item-four-detail-text">
                      <p class="pt_bi_tit">{{ subItem.title }}</p>
                      <p class="pt_bi_promo">{{ subItem.intro }}</p>
                    </div>
                    <div class="item-four-detail-img">
                      <img :src="subItem.img" alt="" />
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 家电专场 -->
      <div class="item-class">
        <div class="item-class-head">
          <!-- <div class="item-class-title">{{ electrical.title }}</div> -->
          <img src="../../static/img/index/title-dq.png" width="100%" class="title-img" alt="title">
          <ul class="item-class-cata item-class-cata-jiadian" v-if="cata[3]">
            <li v-for="(item, index) in cata[3].secCata" :key="index">
              <router-link
                :to="{
                  path: '/goodsList',
                  query: { cata: electrical.id, secCata: item.id },
                }"
                >{{ item.label }}</router-link
              >
            </li>
          </ul>
        </div>
        <div class="item-class-content_wrap content-dinaqi">
          <div
            class="item-class-content"
            v-for="(item, index) in electrical.detail"
            :key="index"
          >
            <div class="item-content-top">
              <div class="item-big-img">
                <!-- <router-link :to="{path: '/goodsList', query: {cata: electrical.id, secCata: 'all'}}"> -->
                <img :src="item.bigImg" width="180" alt="" />
                <!-- </router-link> -->
              </div>
              <div class="item-four-img">
                <div
                  class="item-four-detail"
                  v-for="(subItem, index) in item.itemFour"
                  :key="index"
                >
                  <router-link
                    :to="{
                      path: '/goodsList',
                      query: {
                        cata: electrical.id,
                        secCata: subItem.secCata,
                      },
                    }"
                  >
                    <div class="item-four-detail-text">
                      <p class="pt_bi_tit pt_bi_tit-dianqi">
                        {{ subItem.title }}
                      </p>
                      <p class="pt_bi_promo">{{ subItem.intro }}</p>
                    </div>
                    <div class="item-four-detail-img">
                      <img :src="subItem.img" alt="" />
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search';
import HomeNav from '@/components/nav/HomeNav';
import store from '@/vuex/store';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'Index',
  created () {
    this.loadSeckillsInfo();
    this.loadCarouselItems();
    this.loadComputer();
    this.loadEat();
    this.loadShoppingCart();
    this.loadOffice();
    this.loadElectrical();
    this.setCata();
  },
  mounted () {
    const father = this;
    this.setIntervalObj = setInterval(function () {
      father.REDUCE_SECKILLS_TIME();
    }, 1000);
  },
  data () {
    return {
      setIntervalObj: null
    };
  },
  methods: {
    ...mapActions([
      'loadSeckillsInfo',
      'loadCarouselItems',
      'loadComputer',
      'loadEat',
      'loadShoppingCart',
      'loadOffice',
      'loadElectrical',
      'setCata'
    ]),
    ...mapMutations(['REDUCE_SECKILLS_TIME'])
  },
  computed: {
    ...mapState([
      'seckills',
      'computer',
      'eat',
      'office',
      'electrical',
      'cata'
    ]),
    ...mapGetters(['seckillsHours', 'seckillsMinutes', 'seckillsSeconds'])
  },
  components: {
    Search,
    HomeNav
  },
  destroyed () {
    clearInterval(this.setIntervalObj);
  },
  store
};
</script>

<style scoped>
.container {
  background-color: #f6f6f6;
}
.content {
  width: 1008px;
  margin: 0px auto;
}
/*****************************秒杀专栏开始*****************************/
/*秒杀专栏*/
.seckill {
  width: 100%;
  height: 330px;
  margin: 15px auto;
  background-color: #fff;
}
.seckill-head {
  width: 100%;
  height: 50px;
  background-color: #e01222;
}
.seckill-icon {
  width: 68px;
  height: 100%;
  float: left;
}
.seckill-icon img {
  width: 35px;
  height: 35px;
  margin-top: 6px;
  margin-left: 15px;
  animation-name: shake-clock;
  animation-duration: 0.3s;
  animation-iteration-count: infinite; /*设置无线循环*/
}
/*定义闹钟震动动画关键帧*/
@keyframes shake-clock {
  0% {
    transform: rotate(-8deg);
  }
  50% {
    transform: rotate(8deg);
  }
  100% {
    transform: rotate(-8deg);
  }
}
.seckill-text {
  width: 300px;
  height: 100%;
  float: left;
}
.seckill-text .seckill-title {
  font-size: 22px;
  line-height: 50px;
  color: #fff;
}
.seckill-text .seckill-remarks {
  margin-left: 5px;
  font-size: 10px;
  color: #fff;
}
/*倒计时*/
.count-down {
  height: 100%;
  margin-right: 30px;
  line-height: 50px;
  float: right;
}
.count-down-text {
  color: #fff;
}
.count-down-num {
  padding: 3px;
  border-radius: 5px;
  background-color: #440106;
  font-size: 26px;
  font-weight: bold;
  color: #f90013;
}
.count-down-point {
  font-size: 26px;
  font-weight: bold;
  color: #440106;
}

.seckill-content {
  width: 100%;
  height: 280px;
}
.seckill-item {
  width: 183px;
  height: 250px;
  margin-top: 15px;
  margin-left: 15px;
  box-shadow: 0px 0px 8px #ccc;
  cursor: pointer;
  float: left;
}
.seckill-item-img {
  width: 160px;
  height: 160px;
  margin: 0px auto;
  overflow: hidden;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
}
.seckill-item-img img {
  width: 130px;
  height: 130px;
  margin-left: 15px;
  margin-top: 15px;
  transition: margin-top 0.3s;
}
.seckill-item-img:hover img {
  margin-top: 6px;
  transition: margin-top 0.3s;
}
.seckill-item-info {
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 12px;
  color: #009688;
}
.seckill-item-info i:first-child {
  font-size: 14px;
}
.seckill-price {
  margin-right: 5px;
  font-size: 25px;
  font-weight: bold;
}
/*****************************秒杀专栏结束*****************************/

/*****************************商品专栏开始*****************************/
.item-class {
  width: 100%;
  margin-top: 15px;
}

.item-class-head {
  width: 100%;
  margin-bottom: 30px;
}

.item-class-office-head {
  background-color: #3e3996;
}

.item-class-electrical-head {
  background-color: #777a86;
}

.item-class-head ul {
  list-style: none;
  line-height: 28px;
}
.item-class-head a {
  padding: 6px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6da6be;
  text-decoration: none;
  color: #fff;
}
.item-class-eat-head a {
  background-color: #fdba78;
}

.item-class-office-head a {
  background-color: #7672c0;
}

.item-class-electrical-head a {
  background-color: #a6a9ad;
}

.item-class-title {
  padding-top: 40px;
  padding-bottom: 20px;
  font-size: 32px;
  font-weight: 600;
  color: #333;
  line-height: 50px;
  text-align: center;
  /* background: no-repeat linear-gradient(180deg, transparent 49%, #ccc 49%, #ccc 50%, transparent 50%) 30% 86%; */
}

.title-img {
  margin-top: 40px;
  margin-bottom: 20px;
}

.item-class-cata {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-class-cata-baihuo li a {
  background-color: #77bde6;
}

.item-class-cata-baihuo li a:hover {
  background-color: #1f8ed2;
}

.item-class-cata-bangong li a {
  background-color: #879aaa;
}

.item-class-cata-bangong li a:hover {
  background-color: #557a9a;
}

.item-class-cata-dianzi li a {
  background-color: #a4a3c7;
}

.item-class-cata-dianzi li a:hover {
  background-color: #7572c0;
}

.item-class-cata-jiadian li a {
  background-color: #85c6a6;
}

.item-class-cata-jiadian li:hover a {
  background-color: #489982;
}

.item-class-content_wrap {
  height: 420px;
  padding-top: 120px;
}

.content-baihuo {
  background: url(../../static/img/index/baihuo.png);
}

.content-bangong {
  background: url(../../static/img/index/bangong.png);
}

.content-dinazi {
  background: url(../../static/img/index/dianzi.png);
}

.content-dinaqi {
  background: url(../../static/img/index/dianqi.png);
}

.item-class-content {
  width: 49%;
  cursor: pointer;
  border-right: 1px solid #ccc;
  background-color: #fff;
  float: left;
}
.item-class-content:nth-child(odd) {
  border: none;
  margin-left: 10px;
}
.item-content-top {
  width: 100%;
  height: 260px;
}
.item-big-img {
  width: 180px;
  height: 260px;
  overflow: hidden;
  float: left;
  cursor: auto;
}
.item-big-img img {
  height: 100%;
  width: 100%;
  margin-left: 0px;
  transition: margin-left 0.3s;
}
/* .item-big-img:hover img {
  height: 100%;
  margin-left: -35px;
  transition: margin-left 0.3s;
} */
.item-four-img {
  width: 303px;
  margin-left: 8px;
  float: left;
}
.item-four-detail img {
  margin-left: 0px;
  transition: margin-left 0.3s;
  filter: brightness(1.1);
  object-fit: cover;
  object-position: center;
}
.item-four-detail:hover img {
  margin-left: -6px;
  transition: margin-left 0.3s;
}
.item-four-detail {
  width: 152px;
  height: 130px;
  margin-left: -1px;
  float: left;
}
.item-four-detail:first-child {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.item-four-detail:last-child {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
.item-four-detail-text {
  width: 50px;
  margin-left: 5px;
  margin-top: 15px;
  float: left;
}
.item-four-detail-img {
  width: 96px;
  margin-top: 15px;
  overflow: hidden;
  float: left;
}
.item-four-detail-img img {
  margin-left: 5px;
  width: 90px;
}
.pt_bi_tit {
  margin-top: 8px;
  font-weight: bold;
  font-size: 12px;
  color: #4488a7;
}
.pt_bi_tit-eat {
  color: #ecb127;
}
.pt_bi_tit-bangong {
  color: #3e3996;
}
.pt_bi_tit-dianqi {
  color: #000;
}
.pt_bi_promo {
  color: #00695c;
}
.item-content-bottom {
  width: 100%;
  margin-top: 8px;
}
.item-content-bottom-img {
  width: 156px;
  margin-right: 8px;
  overflow: hidden;
  float: left;
}
.item-content-bottom-img img {
  width: 100%;
  height: 134px;
  margin-left: 0px;
  transition: margin-left 0.3s;
  cursor: auto;
}
/* .item-content-bottom-img:hover img {
  margin-left: -15px;
  transition: margin-left 0.3s;
} */
/*****************************商品专栏结束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/Index.vue